// extracted by mini-css-extract-plugin
module.exports = {"section-container":"report_section-container__2P-td","section":"report_section__1m3CO","question-container":"report_question-container__3sVJ6","hint":"report_hint__2RX6A"};